import { useEffect } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import Home from './pages/home';
import NuestrosProyectos from './pages/nuestros_proyectos';

function LocalizedPage({ page: Page }) {
  const { lang } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isSupportedLanguage = lang === 'es' || lang === 'en';

  useEffect(() => {
    if (!isSupportedLanguage) return;

    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang === 'es' ? 'es-AR' : 'en';
    document.title = t('meta.title');

    const description = document.querySelector('meta[name="description"]');
    if (description) description.content = t('meta.description');
  }, [isSupportedLanguage, lang, t]);

  if (!isSupportedLanguage) return <Navigate to="/es" replace />;
  if (i18n.resolvedLanguage !== lang) return null;

  const isProjectPage = Page === NuestrosProyectos;

  return (
    <Page
      onChangeLanguage={(language) => navigate(isProjectPage ? `/${language}/proyectos` : `/${language}`)}
      onNavigateToProjects={() => navigate(`/${lang}/proyectos`)}
    />
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/es" replace />} />
        <Route path="/:lang/proyectos" element={<LocalizedPage page={NuestrosProyectos} />} />
        <Route path="/:lang" element={<LocalizedPage page={Home} />} />
        <Route path="*" element={<Navigate to="/es" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
